import SharedStorageAgentInterface from "../SharedStorageAgentInterface.js";

class SharedStorageAgentRedux extends SharedStorageAgentInterface {
    constructor(reduxStorePromise, storageInitValue) {
        super();
        this.reduxStorePromise = reduxStorePromise;
        this.storageInitValue = storageInitValue;
    }

    get = async (key=null) => {
        const store = await this._getStore();
        const state = store.getState();
        if (!key) return state;
        return state[key];
    }

    set = async (key, value) => {
        const store = await this._getStore();
        store.dispatch({ 
            type: `set_${key}`, 
            payload: value 
        })
        return this;
    }

    reset = async (key=null) => {
        if (key) {
            await this.set(key, this.storageInitValue[key]);
            return this;
        }
        
        const resetAllPromises = Object.keys(this.storageInitValue).map(initKey => {
            return this.set(initKey, this.storageInitValue[initKey])
        })
        await Promise.all(resetAllPromises)
        return this;
    }

    _getStore = async () => {
        return await Promise.resolve(this.reduxStorePromise);
    }
}

export default SharedStorageAgentRedux;